var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-navigation',[_c('section',{class:_vm.$style.page},[_c('header',{class:_vm.$style.header},[_vm._v(" "+_vm._s(_vm.$t('program.aboutProgram'))+" ")]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }